<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Wiadomości z formularza kontaktowego</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-100"><b>ID:</b> {{ data.id }}</div>
              <div class="md-layout-item md-size-100"><b>Email:</b> {{ data.email }}</div>
              <div class="md-layout-item md-size-100"><b>Data:</b> {{ new Date(data.createdAt).toLocaleString() }}</div>
              <div class="md-layout-item md-size-100"><b>Imię:</b> {{ data.firstName }}</div>
              <div class="md-layout-item md-size-100"><b>Temat:</b> {{ data.subject }}</div>
              <div class="md-layout-item md-size-100"><b>Wiadomość:</b> {{ data.message }}</div>
              <div class="md-layout-item md-size-100">
                <md-checkbox :value="!data.isRead" @change="toggleReadStatus">
                  {{ data.isRead ? "Przeczytane" : "Nieprzeczytane" }}
                </md-checkbox>
              </div>
              <div class="md-layout-item md-size-100">
                <md-button class="md-primary" @click="deleteContactMessage()">Usuń</md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <!-- <div class="md-layout-item md-size-100">
        
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactDetails",
  data() {
    return {
      data: null,
    };
  },
  mounted() {
    this.getContactDetails();
  },
  methods: {
    async getContactDetails() {
      return await this.$axios
        .get(`/contact/${this.$route.params.id}`)
        .then((res) => {
          this.data = res.data;
        })
        .catch((error) => {
          this.data = null;
        });
    },
    async toggleReadStatus() {
      return await this.$axios
        .put(`/contact/change-read-status/${this.$route.params.id}`, {
          isRead: !this.data.isRead,
        })
        .then((res) => {
          this.getContactDetails();
        })
        .catch((error) => {
          this.getContactDetails();
        });
    },
    async deleteContactMessage() {
      return await this.$axios
        .delete(`/contact/${this.$route.params.id}`)
        .then((res) => {
          this.$router.push({ path: "/contact" });
        })
        .catch((error) => {
          this.getContactDetails();
        });
    },
  },
};
</script>
